/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProcedureImplant from './procedure-implant';
import ProcedureImplantDetail from './procedure-implant-detail';
import ProcedureImplantUpdate from './procedure-implant-update';
import ProcedureImplantDeleteDialog from './procedure-implant-delete-dialog';

const ProcedureImplantRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProcedureImplant />} />
    <Route path="new" element={<ProcedureImplantUpdate />} />
    <Route path=":id">
      <Route index element={<ProcedureImplantDetail />} />
      <Route path="edit" element={<ProcedureImplantUpdate />} />
      <Route path="delete" element={<ProcedureImplantDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProcedureImplantRoutes;
